import Modal from './link-tree-object-dialog.vue'

export interface TreeObjectServiceOption {
	render: () => any,									// table内容渲染函数
	data: any[] | (() => Promise<any[]>),				// 表格的数据，或者异步获取数据的函数
	treeConfig: object,									// base table 的 treeConfig 属性

	beforeConfirm?: (selected?: any | any[]) => any,	// 确认前回调函数，阻止确认则返回 Promise.reject
	onConfirm?: (selected: object | object[]) => void,	// 确认回调函数
	onCancel?: () => void,								// 取消回调函数
	title?: string,										// 对话框标题
	dialogProps?: object,								// 对话框属性配置对象
	tableProps?: object,								// table属性参数
}

/**
 * 弹框树形表格选择服务
 * @author  韦胜健
 * @date    2020/10/26 14:54
 */

export function createTreeObjectService($lv: any) {
	let instance: any
	return (option: TreeObjectServiceOption) => {
		if (!instance) {
			instance = $lv.newInstance(Modal)
		}
		instance.show(option)
	}
}